/** Reorder qty lives on `mfg_materials.metadata.reorder_threshold` (no column). */

export function parseReorderThresholdValue(
  raw: unknown
): { ok: true; value: number | null } | { ok: false; error: string } {
  if (raw == null || raw === "") return { ok: true, value: null };
  let n: number;
  if (typeof raw === "number") n = raw;
  else if (typeof raw === "string") {
    const s = raw.replace(/,/g, "").trim();
    if (!s) return { ok: true, value: null };
    n = Number(s);
  } else return { ok: false, error: "Reorder quantity must be a number." };
  if (!Number.isFinite(n) || n < 0) {
    return { ok: false, error: "Reorder quantity must be zero or greater." };
  }
  return { ok: true, value: Math.round(n * 1000) / 1000 };
}

export function parseReorderThresholdInput(
  raw: string
): { ok: true; value: number | null } | { ok: false; error: string } {
  return parseReorderThresholdValue(raw.trim());
}

export function reorderThresholdFromMetadata(
  metadata: Record<string, unknown> | null | undefined
): number | null {
  if (!metadata || typeof metadata !== "object") return null;
  const parsed = parseReorderThresholdValue(metadata.reorder_threshold);
  return parsed.ok ? parsed.value : null;
}

export function mergeReorderThresholdMetadata(
  existing: Record<string, unknown>,
  value: number | null
): Record<string, unknown> {
  const next = { ...existing };
  if (value == null) delete next.reorder_threshold;
  else next.reorder_threshold = value;
  return next;
}
